import type { CSSProperties } from "react";
import { ICON_PATHS, type IconName } from "./paths";

export type { IconName };

export interface IconProps {
  name: IconName;
  /** 视觉尺寸（正方形边长），默认 16 —— 与 14px 正文的行高更协调 */
  size?: number;
  strokeWidth?: number;
  className?: string;
  style?: CSSProperties;
  /** 可访问名称；缺省则图标被视为装饰性（aria-hidden） */
  title?: string;
}

/**
 * 统一图标组件：所有图标共享同一几何规范（24 视图框 / 线性描边 / currentColor）。
 * 颜色一律继承父级 color，不要在图标上写死色值——状态色由容器（按钮/胶囊/标签）决定。
 */
export function Icon({ name, size = 16, strokeWidth = 1.7, className, style, title }: IconProps) {
  const glyph = ICON_PATHS[name];
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={{ flexShrink: 0, ...style }}
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      {title ? <title>{title}</title> : null}
      {glyph}
    </svg>
  );
}

export default Icon;
